import axiosClient from "./axiosClient"

const articleApi = {
  getAll: params =>
    axiosClient.get("/articles/", { params, authRequired: true }),
  getById: id => axiosClient.get(`/articles/${id}/`, { authRequired: true }),
  getTopViewed: () =>
    axiosClient.get("/articles/top_viewed/", { authRequired: true }),
  likeArticle: id =>
    axiosClient.post(`/articles/${id}/like/`, {}, { authRequired: true }),
  unlikeArticle: id =>
    axiosClient.post(`/articles/${id}/unlike/`, {}, { authRequired: true }),
}

export default articleApi
